module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#sort",
      toString: function () {
        return this.url;
      }
    }